module.exports = __webpack_public_path__ + "static/media/cash-and-insurance.ef743128.png";